import { getStores } from '@/stores'

export type RequestChatScrollToBottomOptions = {
  /**
   * true：仅当用户已贴在列表底部附近时才跟滚（对应 store 的「非强制」）。
   * false：无论滚动位置一律滚到底（用户发送、写入会话等）。
   */
  onlyIfPinned: boolean
}

/**
 * 语义化封装 agentV2Store.scrollToBottomView(force)，便于区分「跟读」与「必滚」。
 * Main 仍通过 scrollToBottomViewMark + consumePendingScrollToBottomForce 执行实际滚动。
 */
export function requestChatScrollToBottom(options: RequestChatScrollToBottomOptions) {
  getStores().agentV2Store.scrollToBottomView(!options.onlyIfPinned)
}

/** 仅快贴底时才跟滚，不打断用户看历史 */
export function requestChatScrollToBottomIfPinned() {
  requestChatScrollToBottom({ onlyIfPinned: true })
}

/** 用户主动发消息等场景：始终滚到底 */
export function requestChatScrollToBottomAlways() {
  requestChatScrollToBottom({ onlyIfPinned: false })
}
